import { getOptions } from '@ourbranch/lookups';

export const getHighestEducation = (people) => {
  const options = getOptions('highestEducation');
  const highest = people.reduce((prev, item, i) => {
    const index = options.findIndex((option) => item.highestEducation === option.id);
    return index > i ? i : prev;
  }, 0);
  return people[highest] ? people[highest].highestEducation : '';
};

export const getOldestResident = (people) => {
  return people.reduce((currentOldestAge, person) => Math.max(currentOldestAge, person.age), 0);
};

export const formatValues = (values) => {
  if (!values) {
    return null;
  }
  return {
    ...values,
    oldestResident: undefined,
    highestEducation: undefined
  };
};
